<template>
  <div id="app">
    <div class="app-home section">
      <game-nav />
      <div class="content">
        <about-nav />
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import GameNav from './components/GameNav'
import AboutNav from './components/AboutNav'

export default {
  components: {
    GameNav, AboutNav,
  },
}
</script>

<style lang="scss">
html, body {
  height: 100%;
  max-height: 100%;
  width: 100%;
  max-width: 100%;
}

html {
  overflow-y: hidden;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  max-height: 100%;
  width: 100%;

  .app-home {
    display: flex;
    width: 100%;
    max-width: 100%;
    max-height: 100%;
    height: 100%;
    padding: 0;
  }

  .content {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: calc(100% - 260px);

    .navbar {
      background-color: $dark;
    }
  }
}
</style>
